import React, { useState, useEffect } from 'react';
import { cloudAPI } from '../../utils/api';

export default function RetentionPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getRetention()
            .then(res => {
                const d = res.data;
                const raw = Array.isArray(d) ? d
                          : Array.isArray(d?.cohorts) ? d.cohorts
                          : Array.isArray(d?.rows) ? d.rows
                          : Array.isArray(d?.data) ? d.data
                          : [];
                // Backend: { cohort_week, cohort_size, retention: '[{weeks_since_install, retention_pct}, ...]' }
                // (retention is a JSON string from json_group_array). Project onto the
                // page's cohort/size/week1/week2/week4 shape.
                const rows = raw.map(r => {
                    let weeks = [];
                    const v = r.retention;
                    if (Array.isArray(v)) weeks = v;
                    else if (typeof v === 'string') {
                        try { weeks = JSON.parse(v) || []; } catch { weeks = []; }
                    }
                    const lookup = (n) => {
                        const w = weeks.find(x => Number(x.weeks_since_install) === n);
                        return w?.retention_pct;
                    };
                    return {
                        cohort: r.cohort || r.cohort_week || '-',
                        size:   r.size ?? r.cohort_size ?? 0,
                        week1:  r.week1 ?? lookup(1),
                        week2:  r.week2 ?? lookup(2),
                        week4:  r.week4 ?? lookup(4),
                    };
                });
                setData({ cohorts: rows });
            })
            .catch(err => console.error('Retention error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Retention</h2>
            {data && data.cohorts && data.cohorts.length > 0 ? (
                <div className="bg-white rounded-lg shadow-md p-6">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cohort</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Week 1</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Week 2</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Week 4</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {data.cohorts.map((cohort, idx) => (
                                    <tr key={idx} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cohort.cohort}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cohort.size}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cohort.week1 != null ? `${cohort.week1}%` : '-'}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cohort.week2 != null ? `${cohort.week2}%` : '-'}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{cohort.week4 != null ? `${cohort.week4}%` : '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div className="bg-white rounded-lg shadow-md p-6 text-center text-gray-400">
                    No retention data yet
                </div>
            )}
        </div>
    );
}
